// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/mainMenu/mainMenu.js#1 $
'use strict';

/**
* @ngdoc component
* @name tcApp.component:tcMainMenu
* @description
* # tcMainMenu
* Main Menu component
*/
angular.module('tcApp')
.component('tcMainMenu', {
	controller: 'tcMainMenuCtrl',
	templateUrl: 'template/mainMenu/mainMenu.html'
});
